import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { SurveyDetailPage } from '@/features/surveys/pages/SurveyDetailPage';

export const Route = createFileRoute('/_auth/feedback/surveys/$surveyId/')({
  beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.SURVEY_VIEW),
  parseParams: ({ surveyId }) => {
    const parsedId = Number(surveyId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { surveyId: parsedId };
  },
  component: () => (
    <ErrorBoundary moduleName="Survey Detail">
      <SurveyDetailPage />
    </ErrorBoundary>
  ),
});
